import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { IconComponent } from '../../atoms/icon/icon.component';
import { IndicatorState } from '../../../models/indicator.models';
import { IndicatorStates } from '../../../constants/indicators.constants';
import { TooltipDirective } from '@ui';

@Component({
  selector: 'ui-tsabt-indicator',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ IconComponent, TooltipDirective],
  template: `
    <div class="relative">
      @if (isDanger()) {
        <div class="absolute top-0 -left-[18px] text-error">
          <ui-icon icon="exclamation-circle" theme="fill" />
        </div>
      }
      <div class="flex flex-col gap-y-1">
        <div class="flex gap-x-2">
          @if (showCenterCode()) {
            <span
              class="flex items-center justify-center text-[10px] rounded uppercase px-1 whitespace-nowrap"
              [class]="stateClassMap[state()].code"
            >
              {{ distributorR1() }}
            </span>
          }
          <span
            uiTooltip
            [tooltipTitle]="nameTemplate"
            class="text-xs font-medium uppercase duration-300 transition-colors h-5 max-w-[75%] text-ellipsis whitespace-nowrap overflow-hidden"
            [class]="stateClassMap[state()].label"
            (click)="emitCenter()"
          >
           {{ lineId() }} - {{ name() }}
          </span>
        </div>
         <span class="text-neutral-500 text-xs">{{ centerName() }}</span>
      </div>
    </div>

    <ng-template #nameTemplate>
      <div class="flex flex-col items-center text-xs mt-0.5">
        {{ lineName() }}
      </div>
    </ng-template>
  `,
})
export class TsabtIndicatorComponent {
  state = input<IndicatorState>(IndicatorStates.Default);
  showCenterCode = input<boolean>(false);
  name = input<string>();
  distributorR1 = input<string>();
  distributorId = input<string>();
  centerId = input<string>();
  centerName = input<string>();
  rsabtId = input<string>();
  tsabtId = input<string>();
  lineName = input<string>();
  lineId = input<string>();
  vtnId = input<string>();

  onCenter = output<{
    distributorId: string;
    centerId: string;
    rsabtId: string;
    tsabtId: string;
    vtnId: string;
  }>();

  isDanger = computed(() => this.state() === IndicatorStates.Danger);
  isDisabled = computed(() => this.state() === IndicatorStates.Disabled);

  emitCenter() {
    this.onCenter.emit({
      distributorId: this.distributorId()!,
      centerId: this.centerId()!,
      rsabtId: this.rsabtId()!,
      tsabtId: this.tsabtId()!,
      vtnId: this.vtnId()!,
    });
  }

  stateClassMap: Record<IndicatorState, { code: string; label: string }> = {
    active: {
      code: 'text-black bg-[#D6E4FF]',
      label: 'cursor-pointer text-primary hover:text-tertiary',
    },
    disabled: { code: 'bg-neutral-1 text-neutral-6', label: 'text-neutral-6' },
    danger: {
      code: 'text-black bg-red-2',
      label: 'cursor-pointer text-error hover:text-black',
    },
  };
}
